import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { MinValueValidatorDirective } from './min-value.directive';
import { NumberOnlyValueDirective } from './number-only-value.directive';

@NgModule({
  imports: [CommonModule, FormsModule],
  declarations: [MinValueValidatorDirective, NumberOnlyValueDirective],
  exports: [MinValueValidatorDirective, NumberOnlyValueDirective]
})
export class CustomValidatorModule {}
